import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const TransactionsHistoryList = styled.ul`
    margin: ${(props) => (props.isNewMainScreen ? '0 0 24px 0' : '0 -24px 24px -24px')};

    ${media.tablet720} {
        margin: ${(props) => (props.isNewMainScreen ? '0 0 24px 0' : '0 -32px 24px -32px')};
    }

    li {
        position: relative;
    }
`;

export const TransactionsBlockSubheader = styled.div`
    padding: 16px 24px 32px 24px;
    flex-shrink: 0;

    ${media.tablet720} {
        padding: ${(props) => (props.isNewMainScreen ? '0' : '24px 32px 32px 32px')};
        position: ${(props) => (props.isNewMainScreen ? 'absolute' : null)};
        width: ${(props) => (props.isNewMainScreen ? '198px' : null)};
        left: ${(props) => (props.isNewMainScreen ? '24px' : null)};
        top: ${(props) => (props.isNewMainScreen ? '24px' : null)};
    }

    ${media.tablet937} {
        width: 198px;
        padding: 0;
        position: absolute;
        left: ${(props) => (props.isNewMainScreen ? '24px' : '32px')};
        top: 24px;
    }

    ${media.desktop1224} {
        position: relative;
        left: 0;
        top: 0;
        padding: 16px 0 48px 0;
    }

    ${media.desktop1296} {
        width: 216px;
        padding: 0;
        position: absolute;
        left: 32px;
        top: 24px;
    }
`;

export const TransactionsFeedHeader = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding: 16px 24px;
    cursor: pointer;

    &:hover {
        background: ${(props) => props.theme.grey_8_lc};
        border-radius: 8px;
    }

    &:before {
        background-color: ${(props) => props.theme.purple_100};
        border-radius: 50%;
        content: '';
        height: 8px;
        position: absolute;
        top: 32px;
        left: 8px;
        width: 8px;
        display: ${(props) => (props.showNotificationDot ? 'inline-block' : 'none')};

        ${media.tablet720} {
            top: 44px;
        }
    }

    ${media.tablet720} {
        padding: ${(props) => (props.isNewMainScreen ? '20px 24px' : '24px 32px')};
        margin-left: ${(props) => (props.isNewMainScreen ? '228px' : null)};
    }

    ${media.tablet937} {
        margin-left: ${(props) => (props.isNewMainScreen ? '228px' : '238px')};
    }

    ${media.desktop1224} {
        margin-left: ${(props) => (props.isNewMainScreen ? '228px' : '0')};
    }

    ${media.desktop1296} {
        margin-left: 256px;
    }
`;

export const TransactionsFrame = styled.div`
    flex-grow: 1;
    overflow: hidden;
    margin-left: 16px;

    ${media.desktop1920} {
        margin-left: 24px;
    }
`;

export const TransactionsLineBottom = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
`;

export const TransactionsLineBottomInfo = styled.div`
    display: flex;
    overflow: hidden;
`;
